module.exports = __webpack_public_path__ + "static/media/sg8tj0.0785587d.png";